export default function() {
  const widgetName = 'cardWidget';
  const widgetOpts = cardWidgetOpts;

  function buildItem(item) {
    const url = item.URL;
    const title = item.Title
    const background = item.ImageWithPath.toString();
    const template = `
     <a class="card-widget-item" ${url ? `href="${url}"`:`` }>
     <div class="card-widget-item__background ${title.includes('Campbell') ? "campbell":""}">
        <div class="card-widget-item__background--image" style="background-image:url('${background}')"></div>
        <div class="card-widget-item__background--content">
          <span class="card-widget-title">${title}</span>
        </div>
      </div>
    </a>
    `;
    return template;
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      const items = data.items.map(item => buildItem(item));
      $(`#${widgetName}`).empty().append(items);
      const widgets = $(`#${widgetName} .card-widget-item`);
      applyAOS(widgets, 'fade-down');
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: true,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 6,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true
  });

}